import { Component } from 'react';
import * as Constants from '../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry} from '../common/Global/commonFunctions';
import { logout } from '../../reducers/authSlice';
import { connect } from 'react-redux';
import { persistor } from "../../redux/store";

let userDetails = getLocalStorageVariables();

class Logout extends Component{
    userDetails = getLocalStorageVariables();
    
    componentDidMount(){
        userDetails = getLocalStorageVariables();
        this.Logout();
    }

    Logout = () => {
        fetch(Constants.Logout,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                persistor.purge();
                localStorage.clear();
                window.location = "/";
            }else{
                persistor.purge();
                localStorage.clear();
                window.location = "/";
            }
        }); 
    }
    render() {
        return null;
    }
}
export default connect(null, { logout })(Logout);